import { inject } from "vue";
import { AcquaintApiClient } from "@/services/AcquaintApiClient";
import displayErrorMessage from "@/utils/ErrorHandling";
import { getErrorMessage } from "bright-logic-core/src/errors";
import { PropertyFloorPlanTypes } from "@/enums/properties/PropertyFloorPlanTypes";
import { AcquaintApiNextClient } from "@/services/AcquaintApiNextClient";
import { PropertyListingResponse } from "@/types/properties/ai/PropertyListingResponse";

export function usePropertyListingHelper() {
  const apiClient = inject<AcquaintApiClient>("AcquaintApiClient")!;
  const apiNextClient = inject<AcquaintApiNextClient>("AcquaintApiNextClient")!;

  return {
    fetchFloorPlan: async (
      propertyId: number,
      type: PropertyFloorPlanTypes,
    ) => {
      try {
        return await apiClient.getFile(
          `app/properties/${propertyId}/floorplan?type=${type}`,
        );
      } catch (err) {
        displayErrorMessage(getErrorMessage(err));
      }
    },

    submitFloorPlansToAPI: async (
      propertyId: number,
      image: File,
      planType: PropertyFloorPlanTypes,
    ) => {
      try {
        await apiClient.uploadFile(
          `app/properties/${propertyId}/floorplan/${planType}`,
          image,
        );
        return true;
      } catch (err) {
        displayErrorMessage(getErrorMessage(err));
        return false;
      }
    },

    fetchAICredits: async () => {
      try {
        return await apiNextClient.httpGet<number>(
          "AIResponse/GetAICreditBalance",
        );
      } catch (err) {
        displayErrorMessage(getErrorMessage(err));
        return 0;
      }
    },

    generateAIContent: async (
      propertyId: number,
      selectedPictures: number[],
    ) => {
      try {
        return await apiNextClient.httpPost<PropertyListingResponse>(
          `PropertyListing/${propertyId}`,
          {
            selectedPictures: selectedPictures,
          },
        );
      } catch (err) {
        await displayErrorMessage(
          getErrorMessage("The AI content could not be generated."),
        );
      }
    },
  };
}
